import React, { Component } from "react";
import Moment from "moment";
import { Timeline, TimelineItem } from "vertical-timeline-component-for-react";
import Collapsible from "react-collapsible";
import {
  MomentDateFormat,
  getDateStatusColor,
  TimelineItemDateText,
  IsOpenDescript,
} from "./CustomFuntion";
import "../../styles/timelineItem.css";
import "../../styles/timeline.css";

import { Link } from "office-ui-fabric-react";

interface IState {
  allItems: any;
  otherOlder: any;
  currentMonth: any;
  otherUpcoming: any;
  currentDate: any;
  currentText: string;
  templist: any;
  TodayTask: any;
  documentURL: string;
}

class alltask extends Component<{}, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      allItems: [],
      otherOlder: [],
      currentMonth: [],
      otherUpcoming: [],
      currentDate: new Date(),
      currentText: "",
      templist: [],
      documentURL: "",
      TodayTask: React.createRef(),
    };
  }

  componentDidMount() {
    this.getAPI().then((apiRes: any) => {
      let api = JSON.parse(apiRes);
      this.setState(
        {
          documentURL: api.matterdetail,
        },
        () => {
          this._generateOtherOlder(this.props.items);
          this._generateCurrent(this.props.items);
          this._generateOtherUpcoming(this.props.items);
        },
      );
    });
  }

  getAPI() {
    return new Promise((resolve) => {
      resolve(localStorage.getItem("api"));
    });
  }

  _getOtherStatusIcon(status: string) {
    if (status === "Open") {
      return "red"; //red
    } else {
      return "#2ECC71"; //green
    }
  }

  _getCurrentStatusIcon(dueDate: any, status: string) {
    let itemDate = Moment(dueDate, "YYYY-MM-DD").toDate();
    if (status === "Complete") {
      return "#2ECC71"; //green
    } else {
      if (itemDate < this.state.currentDate) {
        return "red"; //red
      } else {
        return "gold"; //gold
      }
    }
  }

  _generateAllItem(alldata: any) {
    let tempUpcoming = [];
    for (let c = 0; c < alldata.length; c++) {
      tempUpcoming.push(alldata[c]);
    }

    this.setState({
      allItems: tempUpcoming,
    });
  }

  _generateOtherOlder(currItem: any) {
    let tempOverdue = [];
    for (let c = 0; c < currItem.length; c++) {
      let itemDate = Moment(
        currItem[c].data.event.dueDate,
        "YYYY-MM-DD",
      ).toDate();
      if (itemDate < this.state.currentDate) {
        if (itemDate.getFullYear() === this.state.currentDate.getFullYear()) {
          if (itemDate.getMonth() != this.state.currentDate.getMonth()) {
            tempOverdue.push(currItem[c]);
          }
        } else {
          tempOverdue.push(currItem[c]);
        }
      }
    }
    this.setState({
      otherOlder: tempOverdue,
    });
  }

  _generateCurrent(currItem: any) {
    let tempUpcoming = [];
    for (let c = 0; c < currItem.length; c++) {
      let itemDate = Moment(
        currItem[c].data.event.dueDate,
        "YYYY-MM-DD",
      ).toDate();
      if (
        itemDate.getMonth() === this.state.currentDate.getMonth() &&
        itemDate.getFullYear() === this.state.currentDate.getFullYear()
      ) {
        tempUpcoming.push(currItem[c]);
      }
    }
    this.setState({
      currentMonth: tempUpcoming,
    });
  }

  _generateOtherUpcoming(currItem: any) {
    let tempUpcoming = [];
    for (let c = 0; c < currItem.length; c++) {
      let itemDate = Moment(
        currItem[c].data.event.dueDate,
        "YYYY-MM-DD",
      ).toDate();
      if (itemDate > this.state.currentDate) {
        if (itemDate.getFullYear() === this.state.currentDate.getFullYear()) {
          if (itemDate.getMonth() != this.state.currentDate.getMonth()) {
            tempUpcoming.push(currItem[c]);
          }
        } else {
          tempUpcoming.push(currItem[c]);
        }
      }
    }

    this.setState({
      otherUpcoming: tempUpcoming,
    });
  }

  generateOtherOlder() {
    this.state.otherOlder.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });
    return this.state.otherOlder.map((items: any) => {
      return (
        <TimelineItem
          key={items.id}
          dateText={TimelineItemDateText(items.data.event.dueDate)}
          dateInnerStyle={{
            background: getDateStatusColor(items.data.event.dueDate),
          }}
          style={{ color: this._getOtherStatusIcon(items.data.event.status) }}
        >
          <Collapsible
            className={"Collapsible-TimeLineItem"}
            trigger={items.data.event.task}
            open={IsOpenDescript(items.data.event.dueDate)}
            autoFocus={IsOpenDescript(items.data.event.dueDate)}
          >
            <Link
              type="submit"
              href={
                this.state.documentURL +
                "/Matter?matterCode=" +
                items.data.matterCode +
                "#/Workflow"
              }
              target="_blank"
            >
              {items.data.matterCode}
            </Link>
            {` - ${items.data.description}`}
            <hr className="line-item" />
            {items.data.event.assignTo.length > 0 ? (
              <b className="assignToLabel">{"AssignTo: "} </b>
            ) : (
              ""
            )}
            {items.data.event.assignTo.map((assignto: any, index: any) => {
              return <i key={items.id + index}>{assignto.name}, </i>;
            })}
          </Collapsible>
        </TimelineItem>
      );
    });
  }

  generateCurrentMonth() {
    this.state.currentMonth.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });
    return this.state.currentMonth.map((items: any) => {
      return (
        <TimelineItem
          key={items.id}
          dateText={TimelineItemDateText(items.data.event.dueDate)}
          dateInnerStyle={{
            background: getDateStatusColor(items.data.event.dueDate),
          }}
          style={{
            color: this._getCurrentStatusIcon(
              items.data.event.dueDate,
              items.data.event.status,
            ),
          }}
        >
          <Collapsible
            className={"Collapsible-TimeLineItem"}
            trigger={items.data.event.task}
            open={IsOpenDescript(items.data.event.dueDate)}
            autoFocus={IsOpenDescript(items.data.event.dueDate)}
          >
            <Link
              type="submit"
              href={
                this.state.documentURL +
                "/Matter?matterCode=" +
                items.data.matterCode +
                "#/Workflow"
              }
              target="_blank"
            >
              {items.data.matterCode}
            </Link>
            {` - ${items.data.description}`}
            <hr className="line-item" />
            {items.data.event.assignTo.length > 0 ? (
              <b className="assignToLabel">{"AssignTo: "} </b>
            ) : (
              ""
            )}
            {items.data.event.assignTo.map((assignto: any, index: any) => {
              return <i key={items.id + index}>{assignto.name}, </i>;
            })}
          </Collapsible>
        </TimelineItem>
      );
    });
  }

  generateOtherUpcoming() {
    this.state.otherUpcoming.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });
    return this.state.otherUpcoming.map((items: any) => {
      return (
        <TimelineItem
          key={items.id}
          dateText={TimelineItemDateText(items.data.event.dueDate)}
          dateInnerStyle={{
            background: getDateStatusColor(items.data.event.dueDate),
          }}
          style={{
            color: this._getCurrentStatusIcon(
              items.data.event.dueDate,
              items.data.event.status,
            ),
          }}
        >
          <Collapsible
            className={"Collapsible-TimeLineItem"}
            trigger={items.data.event.task}
            open={IsOpenDescript(items.data.event.dueDate)}
            autoFocus={IsOpenDescript(items.data.event.dueDate)}
          >
            <Link
              type="submit"
              href={
                this.state.documentURL +
                "/Matter?matterCode=" +
                items.data.matterCode +
                "#/Workflow"
              }
              target="_blank"
            >
              {items.data.matterCode}
            </Link>
            {` - ${items.data.description}`}
            {items.data.event.assignTo.length > 0 ? (
              <b>
                <hr className="line-item" />
                {"AssignTo :"}{" "}
              </b>
            ) : (
              ""
            )}
            {items.data.event.assignTo.map((assignto: any, index: any) => {
              return <i key={items.id + index}>{assignto.name}, </i>;
            })}
          </Collapsible>
        </TimelineItem>
      );
    });
  }

  public render() {
    return (
      <div className={"all-task-view ms-motion-slideDownIn"}>
        <Collapsible
          id="other-older"
          className="overdue-text"
          trigger={"Older (" + this.state.otherOlder.length + ")"}
          open={false}
          triggerOpenedClassName="overdue-text-span"
        >
          {this.state.otherOlder.length > 0 ? (
            <Timeline lineColor={"#ddd"} animations={true}>
              {" "}
              {this.generateOtherOlder()}{" "}
            </Timeline>
          ) : (
            ""
          )}
        </Collapsible>
        <Collapsible
          id="current-month"
          className="current-month"
          trigger={
            Moment(this.state.currentDate).format("MMMM").toString() +
            "  (" +
            this.state.currentMonth.length +
            ")"
          }
          open={true}
          triggerOpenedClassName="current-text-span"
        >
          {this.state.currentMonth.length > 0 ? (
            <Timeline lineColor={"#ddd"} animations={true}>
              {this.generateCurrentMonth()}{" "}
            </Timeline>
          ) : (
            ""
          )}
        </Collapsible>
        <Collapsible
          id="other-upcoming"
          className="upcoming-text"
          trigger={"Upcoming  (" + this.state.otherUpcoming.length + ")"}
          open={false}
          triggerOpenedClassName="upcoming-text-span"
        >
          {this.state.otherUpcoming.length > 0 ? (
            <Timeline lineColor={"#ddd"} animations={true}>
              {this.generateOtherUpcoming()}{" "}
            </Timeline>
          ) : (
            ""
          )}
        </Collapsible>
      </div>
    );
  }
}

export default alltask;
